export const deleteRiskMatrixService = (fetch) => async (id) => {
  try {
    const response = await fetch({
      url: '/api/v1/matriz-riesgo/' + id,
      method: 'delete',
    });

    return response
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message)
  }
}
